import { render, staticRenderFns } from "./AiAgentSideBar.vue?vue&type=template&id=186ef24c"
import script from "./AiAgentSideBar.vue?vue&type=script&lang=js"
export * from "./AiAgentSideBar.vue?vue&type=script&lang=js"
import style0 from "./AiAgentSideBar.vue?vue&type=style&index=0&id=186ef24c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports